import { useDashboardData } from '@/hooks/useDashboardData'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { useState, useEffect } from 'react'

const PrefectureRankingChart = () => {
  const { data, isLoading, error } = useDashboardData()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  if (isLoading) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center text-red-600">
        データの読み込みに失敗しました
      </div>
    )
  }

  const { championshipsByPrefecture } = data.charts

  // データが空の場合は空の配列を返す
  if (!championshipsByPrefecture || championshipsByPrefecture.length === 0) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center text-gray-500">
        <div>
          <p>データがありません</p>
        </div>
      </div>
    )
  }

  // レスポンシブ対応：PCは上位10件、モバイルは上位10件
  const limit = isMobile ? 10 : 10
  const chartData = championshipsByPrefecture.slice(0, limit)

  return (
    <div className="w-full h-64 sm:h-72 md:h-80 lg:h-96 overflow-x-auto">
      <div className="min-w-[400px] h-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ bottom: 50, left: 0, right: 0, top: 10 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="prefecture" 
              angle={-45}
              textAnchor="end"
              height={50}
              interval={0}
              tick={{ fontSize: 12 }}
            />
                         <YAxis 
               domain={[0, 'dataMax + 1']}
               tick={{ fontSize: 12 }}
               width={40}
               ticks={Array.from({ length: Math.floor(Math.max(...chartData.map(d => d.count))) + 2 }, (_, i) => i)}
             />
            <Tooltip />
            <Bar dataKey="count" fill="#3b82f6" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default PrefectureRankingChart
